import React from "react";
import { CreateButton, List, ShowButton } from "@refinedev/mui";
import { IResourceComponentsProps } from "@refinedev/core";
import { IGrantVestment } from "interfaces/grant-vestment";
import { InfiniteList } from "components/list/infinity-list";
import { useNavigate } from "react-router-dom";
import { shortFormat } from "utils/date-format";
import { moneyFormat } from "utils/money-format";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ActionButton, ActionMenuItem } from "components/action-button";

const ACTIVE_GRANT_VESTMENT_STATUSES = [
  "RAISING",
  "CLOSED",
  "CANCELED",
  "DRAFT",
  "EXITED",
  "PROMOTING",
];

export const GrantVestmentList: React.FC<IResourceComponentsProps> = () => {
  const navigate = useNavigate();

  return (
    <>
      <List
        title="GrantVestment List"
        wrapperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 2,
          },
        }}
        headerButtons={
          <>
            <CreateButton
              onClick={() => navigate("/grant-vestments/create")}
              variant="contained"
              color="primary"
              sx={{
                marginLeft: "auto",
                marginBottom: 2,
              }}
            />
            <ShowButton
              onClick={() => navigate("/grant-vestments/interactions")}
              variant="contained"
              color="primary"
              startIcon={<FavoriteBorderIcon />}
              children="Likes"
              sx={{
                marginLeft: "auto",
                marginBottom: 2,
              }}
            />
          </>
        }
      >
        <InfiniteList<IGrantVestment>
          endpoint="grant-vestments"
          limit={10}
          queryParams={{ "filter[status]": ACTIVE_GRANT_VESTMENT_STATUSES }}
          isTable={true}
          columns={[
            {
              field: "name",
              header: "Name",
            },
            {
              field: "projectBy",
              header: "Projected By",
            },
            {
              header: "Goal",
              renderCell: function render({ goalAmount }) {
                return `${moneyFormat(goalAmount)}`;
              },
            },
            {
              header: "GrantVestors",
              renderCell: function render({ grantVestorCounter }) {
                return `${grantVestorCounter} Investors`;
              },
            },
            {
              field: "status",
              header: "Status",
            },
            {
              header: "Deadline",
              renderCell: function render({ deadline }) {
                return shortFormat(deadline);
              },
            },
            {
              field: "status",
              header: "status",
            },

            {
              header: "Actions",
              renderCell: function render({ grantVestmentId }) {
                const menuItems: ActionMenuItem[] = [
                  {
                    name: "View",
                    icon: <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />,
                    navigateUrl: (id) => `/grant-vestments/${id}`,
                  },
                  {
                    name: "Duplicate",
                    icon: <ContentCopyIcon sx={{ fontSize: 20 }} />,
                    navigateUrl: (id) => `/grant-vestments/create?duplicate_from=${id}`,
                  },
                ];

                return (
                  <ActionButton id={grantVestmentId} menuItems={menuItems} />
                );
              },
            },
          ]}
          tableProps={{
            stickyHeader: true,
            headerBgColor: "grey.200",
            responsive: true,
          }}
          searchConfig={{
            enabled: true,
            placeholder: "Search GrantVestment...",
            searchField: "searchTerm",
          }}
          emptyMessage={`No GrantVestment found!`}
        />
      </List>
    </>
  );
};
